export const ROUTE_PATHS = {
  root: "/",
  login: "/login",
  forgetPassword: "/forget-password",
  changePassword: "/change-password",
  resetPassword: "/reset-password",
  products: "/products",
  productsRequests: "/products/review-requests",
  approvedProducts: "/products/approved-products",
  productDetailsRequest: "/products/review-requests/:id",
  productDetailsApproved: "/products/approved-products/:id",
  categories: "/categories",
  approvedCategories: "/categories/approved-categories",
  categoryDetailsApproved: "/categories/approved-categories/:id",
  categoriesRequests: "/categories/review-categories",
  categoriesRequestsDetails: "/categories/review-categories/:id",
  addCategory: "/categories/add",
  editCategory: "/categories/:id/edit",
  subCategories: "/sub-category",
  addSubCategories: "/sub-category/add",
  editSubCategories: "/sub-category/:id/edit",
  subcategoryDetails: "/sub-category/:id",
  notifications: "/notifications",
  users: "/users",
  usersCombined: "/users/combined",
  usersCombinedDetails: "/users/combined/:id/company/:companyId",
  usersImporters: "/users/importers",
  usersImporterDetails: "/users/importers/:id",
  usersExporters: "/users/exporters",
  usersExporterDetails: "/users/exporters/:id/company/:companyId",
  verificationSubscription: "/verification-subscription",
  businessVerification:
    "/verification-subscription/business-verification",
  verificationRequests:
    "/verification-subscription/business-verification/verification-requests",
  verificationRequestDetails:
    "/verification-subscription/business-verification/verification-requests/:type/:id",
  vouchers: "/verification-subscription/vouchers",
  transactions: "/verification-subscription/transactions",
  employees: "/employees",
  employeesList: "/employees/list",
  addEmployees: "/employees/add",
  employeeDetails: "/employees/:id",
  editEmployee: "/employees/:id/edit",
  roles: "/roles",
  addRole: "/roles/add",
  editRole: "/roles/:id/edit",
  roleDetails: "/roles/:id",
  notFound: "/not-found"
};
